export const OFFICE_EXTENSIONS = [
  "doc",
  "docx",
  "xls",
  "xlsx",
  "ppt",
  "pptx",
];

export const DOCUMENT_EXTENSIONS = ["pdf", ...OFFICE_EXTENSIONS];
